import React from "react";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { useEditCameraStore } from "../editCameraStore/editCameraStore";
import { getDefaultAlarmName } from "../../../utils/getDefaultAlarmName";

export const checkForAlarmType = (
  alarmId: number,
  setBoldAlertsOnCamera: Dispatcher<boolean>,
  setPatriotAlertsOnCamera: Dispatcher<boolean>,
  setSureViewAlertsOnCamera: Dispatcher<boolean>,
  setSentinelAlertsOnCamera: Dispatcher<boolean>,
  setImmixAlertsOnCamera: Dispatcher<boolean>,
  setWebhooksAlertsOnCamera: Dispatcher<boolean>,
  setSoftguardAlertsOnCamera: Dispatcher<boolean>,
  setEvalinkAlertsOnCamera: Dispatcher<boolean>,
  setDiceAlertsOnCamera: Dispatcher<boolean>
) => {
  if (!localStorage.alarmOptions) {
    return;
  }

  const alarmType = getDefaultAlarmName(alarmId);

  if (alarmType === "Bold") {
    setBoldAlertsOnCamera(true);
  }
  if (alarmType === "Patriot") {
    setPatriotAlertsOnCamera(true);
  }
  if (alarmType === "SureView") {
    setSureViewAlertsOnCamera(true);
  }
  if (alarmType === "Sentinel") {
    setSentinelAlertsOnCamera(true);
  }
  if (alarmType === "Immix") {
    setImmixAlertsOnCamera(true);
  }
  if (alarmType === "Dice") {
    setDiceAlertsOnCamera(true);
  }
  if (alarmType === "Webhooks") {
    setWebhooksAlertsOnCamera(true);
  }
  if (alarmType === "Softguard") {
    setSoftguardAlertsOnCamera(true);
  }
  if (alarmType === "Evalink") {
    setEvalinkAlertsOnCamera(true);
  }
  if (alarmType === "Sysaid") {
    useEditCameraStore.getState().setSysaidAlertsOnCamera(true);
  }
};
